import { useState } from "react";
import { Check, Ban, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";
import { REASONS, eurOr } from "@/lib/wh";
import { useAuth } from "@/context/AuthContext";
import { can } from "@/lib/roles";

const CASH = [["", "Non registrare"], ["contanti", "Contanti"], ["pos", "POS"]];

export function CashChoice({ value, onChange }) {
  return (
    <div className="space-y-1.5" data-testid="sr-cash-choice">
      <Label>Registra anche in Incassi</Label>
      <div className="grid grid-cols-3 gap-2">
        {CASH.map(([k, l]) => (
          <button key={k} type="button" onClick={() => onChange(k)} data-testid={`sr-cash-${k || "none"}`}
            className={`h-10 rounded-xl border text-sm font-semibold transition-colors ${value === k ? "bg-[var(--ink)] text-white border-[var(--ink)]" : "bg-white border-[var(--border)]"}`}>{l}</button>
        ))}
      </div>
    </div>
  );
}

export function SellRemoveDialog({ item, mode, onClose, onDone }) {
  const [qty, setQty] = useState(1);
  const [price, setPrice] = useState("");
  const [reason, setReason] = useState("altro");
  const [note, setNote] = useState("");
  const [cash, setCash] = useState("");
  const [busy, setBusy] = useState(false);
  const { user } = useAuth();
  if (!item) return null;
  const sell = mode === "sell";
  const suggested = item.sale_price != null ? item.sale_price * (Number(qty) || 0) : null;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const body = sell ? { qty: Number(qty), price: price === "" ? null : Number(price), cash_kind: cash || null } : { qty: Number(qty), reason, note };
      const { data } = await api.post(`/wh/items/${item.id}/${sell ? "sell" : "remove"}`, body);
      toast.success(sell ? (cash ? "Vendita registrata anche in Incassi" : "Vendita registrata") : "Articolo segnato come rimosso");
      onDone(data);
      onClose();
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid={sell ? "sell-dialog" : "remove-dialog"}>
        <DialogHeader>
          <DialogTitle>{sell ? "V – Segna come venduto" : "Segna come rimosso"}</DialogTitle>
          <DialogDescription>{item.code} · disponibili {item.qty_available} su {item.quantity}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5"><Label>Quantità</Label><Input type="number" min={1} max={item.qty_available} required value={qty} onChange={(e) => setQty(e.target.value)} data-testid="sr-qty-input" /></div>
          {sell ? (
            <div className="space-y-1.5"><Label>Prezzo effettivo totale (€)</Label>
              <Input type="number" step="0.01" min="0" value={price} onChange={(e) => setPrice(e.target.value)} placeholder={suggested != null ? `Prezzo di vendita: ${eurOr(suggested)}` : "Importo incassato"} data-testid="sr-price-input" />
              <p className="text-xs text-[var(--muted)]">Lascia vuoto per usare il prezzo di vendita della scheda.</p></div>
          ) : (
            <>
              <div className="space-y-1.5"><Label>Motivo</Label>
                <select value={reason} onChange={(e) => setReason(e.target.value)} className="h-10 w-full rounded-md border border-[var(--border)] px-3 text-sm bg-white" data-testid="sr-reason-select">
                  {REASONS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
                </select></div>
              <div className="space-y-1.5"><Label>Nota (facoltativa)</Label><Input maxLength={500} value={note} onChange={(e) => setNote(e.target.value)} data-testid="sr-note-input" /></div>
            </>
          )}
          {sell && can(user, "cash") && <CashChoice value={cash} onChange={setCash} />}
          <button disabled={busy} className={`h-11 px-5 w-full ${sell ? "btn-primary" : "btn-secondary text-red-600"}`} data-testid="sr-confirm-button">
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : sell ? <Check className="h-5 w-5" /> : <Ban className="h-5 w-5" />} Conferma
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
